import { render, staticRenderFns } from "./ListExteriorCargoView.vue?vue&type=template&id=dffb4f26&"
import script from "./ListExteriorCargoView.vue?vue&type=script&lang=ts&"
export * from "./ListExteriorCargoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports